import * as React from 'react';
import { ISearchLocation } from '../../helpers';
import {
	Button, ButtonType
} from 'office-ui-fabric-react';
import { CSSProperties } from 'react';

interface IProps {
	searchLocation: ISearchLocation;
	setSearchLocation: (id: any, elementId: string, passedSubmissionComponent: boolean) => void;
	element: any;
	passedSubmissionComponent: boolean;
	style?: CSSProperties;
	toggleNewComponentDialog?: () => void;

}

export class AddButton extends React.Component<IProps, any> {

	public render() {
		let { searchLocation, toggleNewComponentDialog, setSearchLocation, element, passedSubmissionComponent, style } = this.props;

		return (
			<Button
				style={style}
				buttonType={ButtonType.icon}
				icon='Add'
				title={"Add a component"}
				className={'action add-search badge-circle'}
				onClick={() => {
					toggleNewComponentDialog();
					setSearchLocation(searchLocation, element.elementId, passedSubmissionComponent);
				}
				}
			/>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/search/add-button.tsx